// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  /* Match the height of input elements */
  height: 38px;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/buttons/buttons.component.scss"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,YAAA;AACF","sourcesContent":["button {\n  /* Match the height of input elements */\n  height: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
